import classnames from 'classnames';
import classNames from 'classnames';
import React, { MouseEvent, useMemo } from 'react';

import Button from 'common/components/Button';
import useTechnoPremium from 'common/components/ShowtimeModal/hooks/useTechnoPremium';
import { SHOWTIMES_EXPERIENCES_ICONS_CLASSES } from 'common/constants/Showtimes';
import {
  TheaterReservationTracking,
  TrackingEventNames
} from 'common/constants/trackingEventsNames';
import { CloseModal } from 'common/module/ui/lazy-modal/types';
import eventEmitter from 'common/services/events/eventEmitter';
import trans from 'common/tools/translations/trans';

import styles from './styles.module.scss';

export type BookingButtonProps = {
  closeModal: CloseModal;
  experiences: string[];
  loading: boolean;
  ticketingUrl?: string | null;
  trackingContext: TheaterReservationTracking;
};

const bookingUnavailableLabel = trans('showtimes.booking-unavailable.modal');
const bookingCloseLabel = trans('showtimes.modal.close');
const BookingButton = ({
  closeModal,
  experiences,
  loading,
  ticketingUrl,
  trackingContext
}: BookingButtonProps) => {
  const technoPremium = useTechnoPremium(experiences);

  const experienceTag = useMemo(() => technoPremium?.tag, [technoPremium]);
  const bookingLabel = useMemo(
    () =>
      technoPremium
        ? trans('showtimes.booking.modal.premium', {
            techno: technoPremium.translation
          })
        : trans('showtimes.booking.modal'),
    [technoPremium]
  );
  const handleClick = () => {
    eventEmitter.emit(
      TrackingEventNames.THEATER_RESERVATION_LINK_CLICK_EVENT,
      trackingContext
    );
  };

  const handleClose = (
    evt: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
  ) => {
    evt.preventDefault();
    closeModal();
  };

  return loading ? null : ticketingUrl ? (
    <div className={classnames('hred', styles.lastHred, styles.centeredButton)}>
      <Button
        className={
          experienceTag &&
          classNames(
            'label-with-no-icon',
            'icon-label',
            `icon-${SHOWTIMES_EXPERIENCES_ICONS_CLASSES[experienceTag]}`
          )
        }
        href={ticketingUrl}
        onClick={handleClick}
        targetHref
        theme="inverse"
        type="full"
      >
        {bookingLabel}
      </Button>
    </div>
  ) : (
    <div className={classnames('hred', styles.lastHred)}>
      <p className={styles.bookingUnavailable}>{bookingUnavailableLabel}</p>
      <a className={styles.close} onClick={handleClose}>
        {bookingCloseLabel}
      </a>
    </div>
  );
};

export default BookingButton;
